import { forwardRef } from "react";
import { SESSION_PLAYER_ID, SESSION_PLAYER_PADDING } from "../utils";
import { makeStyles } from "@material-ui/styles";

export const PlayerAnchor = forwardRef((_, ref) => {
  const classes = useStyle();
  
  return (
    <div
      ref={ref}
      id={SESSION_PLAYER_ID}
      className={classes.root}
    />
  )
});

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "100%",
    display: "flex",
    justifyContent: "center",
    position: "relative",
    height: "calc(100% - 68px)",
    marginBottom: SESSION_PLAYER_PADDING,
    "& > div": {
      position: "absolute",
      top: "50%",
    },
    "& iframe": {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
}));